export const getUserProfile = async (token: string) => {
    const myProfileUrl = "https://graph.microsoft.com/v1.0/me/";
    return await fetch(myProfileUrl, {
        method: "GET",
        headers: {
            Authorization: `Bearer ${token}`,
            ContentType: "application/json"
        }
    });
}
